"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculation_common_1 = require("./calculation-common");
class LevelCalculator {
    constructor(options) {
        this.options = options;
        this.common = new calculation_common_1.Common(options.levelCount);
    }
    calculate(questionCounts, goodCounts, wrongCounts) {
        const hardestLevel = this.common.hardestLevel(questionCounts);
        if (hardestLevel < 0) {
            return 0;
        }
        const plusComposition = this.common.distributeComposition(questionCounts, hardestLevel, this.options.nonHardestReversedWeights);
        const minusComposition = this.common.distributeComposition(questionCounts, hardestLevel, this.options.nonHardestReversedMinusWeights);
        const plusSum = this.common.sum(plusComposition);
        const minusSum = this.common.sum(minusComposition);
        let plus = 0;
        let minus = 0;
        for (let i = 0; i < hardestLevel; i++) {
            const plusWeight = calculateWeight(plusComposition[i], plusSum);
            const minusWeight = calculateWeight(minusComposition[i], minusSum);
            plus += calculateScore(questionCounts[i], goodCounts[i], plusWeight);
            minus += calculateScore(questionCounts[i], wrongCounts[i], minusWeight);
        }
        plus = plus * this.options.nonHardestMaximumLevel;
        const hardest = (goodCounts[hardestLevel] - wrongCounts[hardestLevel]) / questionCounts[hardestLevel];
        let level = Math.max(plus, hardest) - minus;
        if (level < 0) {
            level = 0;
        }
        return level;
        function calculateWeight(value, sum) {
            return sum === 0 ? 0 : value / sum;
        }
        function calculateScore(all, count, weight) {
            return all === 0 ? 0 : (count / all) * weight;
        }
    }
}
exports.LevelCalculator = LevelCalculator;
//# sourceMappingURL=level-calculator.js.map